module.exports = __webpack_public_path__ + "img/side-icon-51.027e3088.svg";